import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { ISlotList } from '../../../Pages/Slot/ISlot';

interface IUpdate extends IReduxState<ISlotList> {
  spaceupdateableDate?: ISlotList;
}

export const UpdateSpaceOrderSlicer = createSlice({
  name: 'UpdateSpaceOrder',
  initialState: {
    data: {},
    isLoading: false,
    updateableDate: {},
  } as IUpdate,
  reducers: {
    updateSpaceOrder: (state, _) => {
      state.isLoading = true;
    },
    successUpdateSpaceOrder: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureUpdateSpaceOrder: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    SpacesUpdateableDataOrder: (state, action) => {
      state.spaceupdateableDate = action.payload;
    },
    clearUpdateSpaceOrderState: (state) => {
      state.data = {};
      state.spaceupdateableDate = undefined;
    },
    clearUpdateableDataOrder: (state) => {
      state.spaceupdateableDate = undefined;
    },
  },
});

export const {
  updateSpaceOrder,
  failureUpdateSpaceOrder,
  successUpdateSpaceOrder,
  SpacesUpdateableDataOrder,
  clearUpdateSpaceOrderState,
  clearUpdateableDataOrder,
} = UpdateSpaceOrderSlicer.actions;

export default UpdateSpaceOrderSlicer.reducer;
